module.exports = __webpack_public_path__ + "3715f150b1cad29d9b3d0d70cc8397c2.png";


//////////////////
// WEBPACK FOOTER
// ./public/pic_about_2@2x.png
// module id = 217
// module chunks = 1